<div class="page-container">
  <div class="o-flex o-flex--justify-space-between o-flex--align-items-center">
    <span class="general-info--font-size-35 line-height-40">Settings</span>
    <app-search [config]="searchConfig" [searchObservable$]="searchObservable$"></app-search>
  </div>
  <span class="u-font-weight-bold u-font-size-16 u-margin-bottom-20 u-margin-top-10 u-display-block">Customize your sports, metrics and additional features</span>
  <app-tab [config]="tabConfig"></app-tab>
</div>
